module.exports = __webpack_public_path__ + "static/media/TwmLogo.1fe5675f.png";